// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Scrollable from "../../../../../../library/components/Scrollable.bs.js";
import * as OrderLogsView from "./components/OrderLogsView.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TicketingOrderLogs from "../../../../to-be-migrated/domain/types/order/TicketingOrderLogs.bs.js";
import * as TicketingOrderRepoManager from "../../../app/order/repo/order/TicketingOrderRepoManager.bs.js";

function reducer(_state, action) {
  return action._0;
}

function OrderLogsContainer(Props) {
  var order_id = Props.order_id;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(reducer, {
        order_logs: {
          TAG: /* Loading */0,
          _0: undefined
        },
        offset: undefined,
        end_of_logs: false
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  var fetchPreviousLogs = function (param) {
    var match = state.order_logs;
    switch (match.TAG | 0) {
      case /* Loading */0 :
          var order_logs = match._0;
          if (order_logs !== undefined) {
            return order_logs;
          } else {
            return /* [] */0;
          }
      case /* Live */1 :
          return match._0;
      case /* Error */2 :
          return /* [] */0;
      
    }
  };
  var fetchOrderLogs = function (param) {
    var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._3(RepoInstance.fetchOrderLogs, order_id, TicketingOrderLogs.toString(state.offset), country);
                }), (function (data) {
                  var match = data.offset;
                  return Curry._1(dispatch, /* OrderLogs */{
                              _0: {
                                order_logs: {
                                  TAG: /* Live */1,
                                  _0: Pervasives.$at(fetchPreviousLogs(undefined), data.order_logs)
                                },
                                offset: data.offset,
                                end_of_logs: match === undefined
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, /* OrderLogs */{
                              _0: {
                                order_logs: {
                                  TAG: /* Error */2,
                                  _0: error
                                },
                                offset: state.offset,
                                end_of_logs: state.end_of_logs
                              }
                            });
                }));
  };
  var onScrollEndCallback = function (param) {
    var _order_logs = state.order_logs;
    switch (_order_logs.TAG | 0) {
      case /* Live */1 :
          if (!state.end_of_logs) {
            var match = state.order_logs;
            var exit = 0;
            var order_logs;
            switch (match.TAG | 0) {
              case /* Loading */0 :
                  var order_logs$1 = match._0;
                  if (order_logs$1 !== undefined) {
                    order_logs = order_logs$1;
                    exit = 2;
                  } else {
                    exit = 1;
                  }
                  break;
              case /* Live */1 :
                  order_logs = match._0;
                  exit = 2;
                  break;
              case /* Error */2 :
                  exit = 1;
                  break;
              
            }
            switch (exit) {
              case 1 :
                  return Curry._1(dispatch, /* OrderLogs */{
                              _0: {
                                order_logs: {
                                  TAG: /* Loading */0,
                                  _0: undefined
                                },
                                offset: state.offset,
                                end_of_logs: state.end_of_logs
                              }
                            });
              case 2 :
                  return Curry._1(dispatch, /* OrderLogs */{
                              _0: {
                                order_logs: {
                                  TAG: /* Loading */0,
                                  _0: order_logs
                                },
                                offset: state.offset,
                                end_of_logs: state.end_of_logs
                              }
                            });
              
            }
          } else {
            return ;
          }
      case /* Loading */0 :
      case /* Error */2 :
          return ;
      
    }
  };
  React.useEffect((function () {
          var _data = state.order_logs;
          switch (_data.TAG | 0) {
            case /* Loading */0 :
                fetchOrderLogs(undefined);
                break;
            case /* Live */1 :
            case /* Error */2 :
                break;
            
          }
          
        }), [state.order_logs]);
  var order_logs = state.order_logs;
  switch (order_logs.TAG | 0) {
    case /* Loading */0 :
        var order_logs$1 = order_logs._0;
        if (order_logs$1 !== undefined) {
          return React.createElement(Scrollable.make, {
                      height: "100%",
                      onScrollEndCallback: (function (param) {
                          
                        }),
                      children: OrderLogsView.getView(order_logs$1)
                    });
        } else {
          return React.createElement("div", undefined, "Fetching Order Logs");
        }
    case /* Live */1 :
        return React.createElement(Scrollable.make, {
                    height: "100%",
                    onScrollEndCallback: onScrollEndCallback,
                    children: OrderLogsView.getView(order_logs._0)
                  });
    case /* Error */2 :
        return React.createElement("div", undefined, "Error Fetching Order Logs. Try Submitting again");
    
  }
}

var make = OrderLogsContainer;

export {
  reducer ,
  make ,
  
}
/* react Not a pure module */
